/**
 * myPatria wordmark — the platform name everywhere the app itself is titled.
 * "my" is lowercase italic serif; "Patria" is regular-weight elegant serif.
 * Deep forest green by default; falls back to the parent color via `inherit`
 * when placed on darker surfaces.
 *
 * NOTE: "PATRIA CHURCH" as the CHURCH brand stays as-is — this component
 * is only for the platform name.
 */
export default function MyPatriaWordmark({
  size = "md",
  className = "",
  as: Tag = "span",
  "data-testid": testId = "mypatria-wordmark",
}) {
  const sizes = {
    xs: "text-lg",
    sm: "text-xl",
    md: "text-2xl sm:text-3xl",
    lg: "text-4xl sm:text-5xl",
    xl: "text-5xl sm:text-6xl",
  };
  return (
    <Tag
      className={`font-serif tracking-tight text-forest-900 leading-none ${sizes[size]} ${className}`}
      data-testid={testId}
    >
      <span className="italic font-light">my</span>
      <span className="font-medium">Patria</span>
    </Tag>
  );
}
